import React, { useEffect, useState } from "react";
import VersiWapLogo from "../../../../../assets/images/Header/versi-web.svg";
import versiwapicon from "../../../../../assets/images/Icons/icons/wap.svg";
import versiwebicon from "../../../../../assets/images/Icons/icons/WWW.svg";
import InfoIcon from "../../../../../assets/images/Icons/info_icon.svg";
import { setCommonConfig } from "../../../../../redux/actions.js";
import { useDispatch, useSelector } from 'react-redux';
import { makeAjax, respStatus, showMessage, url } from "../../../../../helpers/global_helper";
import { withTranslation } from "react-i18next";
import InformasiResultPopup from "../../../SubComponents/RightTable/InformasiResultPopup.js";
import InformasiPopup from "./InformasiPopup.js";
import { IoMdClose } from "react-icons/io";

function VersiWAP(props) {
	const dispatch = useDispatch();
	const app_type = useSelector((state) => state.CommonConfig.app_type);
	const game_sub_type = useSelector((state) => state.GameSubType.game_sub_type);
	const game_sub_child_type = useSelector((state) => state.GameSubType.game_sub_child_type);
	const country_name = useSelector((state) => state.CommonConfig.country_name);
	const gameId = useSelector((state) => state.CommonConfig.gameId);
	const gameType = useSelector((state) => state.CommonConfig.gameType) ?? "4d3d2d";
	const discountPrize = useSelector((state) => state.CommonConfig.discount);
	const [isInfoResultPopup, setIsInfoResultPopup] = useState(false);
	const [isInfoPopup, setIsInfoPopup] = useState(false);

	const [reqData, setReqData] = useState({ gameId: gameId, type: game_sub_child_type });
	const [respData, setRespData] = useState([]);

	const openInformasiResultPopup = () => {
		setIsInfoResultPopup(true);
	};
	const closeInformasiResultPopup = () => {
		setIsInfoResultPopup(false);
	};

	useEffect(() => {
		// openInformasiPopup();
		setReqData({ gameId: gameId, type: game_sub_child_type })
	}, [game_sub_child_type]);

	const openInformasiPopup = () => {
		makeAjax(url.TOGEL_API.getAllPrizeDiscount, reqData)
			.then(response => {
				if (response.status !== respStatus['SUCCESS']) {
					if (response.code == "market_close_err") {
						showMessage(props.t('referresh_page'), "error", "error")
						return;
					}
				}
				setIsInfoPopup(true);
				setRespData(response.data);
			});
	};
	const closeInformasiPopup = () => {
		setIsInfoPopup(false);
	};

	const changeAppType = () => {
		let temp_app_type = "wap";
		if (app_type == "wap") temp_app_type = "desktop";
		dispatch(setCommonConfig({ key: "app_type", value: temp_app_type }));
	};
	const validPaths = [
		"/game/Fifty_Fifty",
		"/game/Fifty_Fifty_2D",
		"/game/Tengah_Dasar",
		"/game/Silang_Kembang"
	];

	return (
		<div className='versiWap_mo_wrapper'>
			{/* <div className='versiWap_mo_left'>
				<p>{props.t('market')} : <span onClick={openInformasiResultPopup}>{country_name}</span></p>
				<p>Periode : {discountPrize.game_code} - {discountPrize.nextPeriode}</p>
			</div>
			<div className='versiWap_mo_center'>
				<p ><img src={InfoIcon} alt='' className='versi_mo_info_icon' onClick={openInformasiPopup} /> {game_sub_child_type == "FULLBET" ? "" : "Discount:"}</p>

				{window.location.pathname === "/" ||
					window.location.pathname === "/game/Four_D" ||
					window.location.pathname === "/game/Quick_Buy" ||
					window.location.pathname === "/game/Bbfs" ||
					window.location.pathname === "/game/pola_tarung" ||
					window.location.pathname === "/game/ThreeDDepan" ||
					window.location.pathname === "/game/TwoDDepan" ||
					window.location.pathname === "/game/TwoDTengah" ||
					window.location.pathname === "/game/bolak_balik" ? (
					game_sub_type === "QUICK_BUY" ? (
						<>
							<p>4D:  <span className="righttble_bluetxt">{discountPrize.showDisc4d}%</span></p>
							<p>3D:  <span className="righttble_bluetxt">{discountPrize.showDisc3d}%</span></p>
							<p>2D:  <span className="righttble_bluetxt">{discountPrize.showDisc2d}%</span></p>
							<p>Colok Bebas:  <span className="righttble_bluetxt">{discountPrize.showDiscColokBebas}%</span></p>
							<p>Colok Bebas 2D:  <span className="righttble_bluetxt">{discountPrize.showDiscColokBebas2d}%</span> </p>
							<p>Colok Naga:  <span className="righttble_bluetxt">{discountPrize.showDiscColokNaga}%</span> </p>

							<p>Colok Jitu:  <span className="righttble_bluetxt">{discountPrize.showDiscColokJitu}%</span></p>
							<p>Tengah/Tepi:  <span className="righttble_bluetxt">{discountPrize.showDiscTengahTepi}%</span> </p>
							<p>5050:  <span className="righttble_bluetxt">{discountPrize.showDisc5050}%</span></p>
							<p>5050 2D:  <span className="righttble_bluetxt"> {discountPrize.showDiscKombinasi}%</span></p>
							<p>Shio:  <span className="righttble_bluetxt"> {discountPrize.showDiscShio}%</span></p>
							<p>Silang Homo:  <span className="righttble_bluetxt"> {discountPrize.showDiscSilangHomo}%</span></p>

						</>
					) :
						<>
							{
								(game_sub_type === "4d3d2d" || game_sub_type == "bbcampuran" || game_sub_type == "TwoDDepan" || game_sub_type == "TwoDTengah" || game_sub_type == "polatarung" || game_sub_type == "bolak_balik") ?

									game_sub_child_type == "DISCOUNT" ?
										<p>4D:{discountPrize.showDisc4d}%,3D:{discountPrize.showDisc3d}%,2D:{discountPrize.showDisc2d}%</p>
										: game_sub_child_type == "FULLBET" ?
											<p></p>
											: game_sub_child_type == "PRIZE" ?
												<p>4D:{discountPrize.showDisc4dPrize123 ? discountPrize.showDisc4dPrize123 : 0}%,3D:{discountPrize.showDisc3dPrize123 ? discountPrize.showDisc3dPrize123 : 0}%,2D:{discountPrize.showDisc2dPrize123 ? discountPrize.showDisc2dPrize123 : 0}%</p>
												: <p>4D:{discountPrize.showDisc4d}%,3D:{discountPrize.showDisc3d}%,2D:{discountPrize.showDisc2d}%</p>

									: game_sub_type === "3DDEPAN" ?
										game_sub_child_type == "DISCOUNT" ?
											<p>3D:{discountPrize.showDisc3d}%</p>
											: game_sub_child_type == "FULLBET" ?
												<p></p>
												: game_sub_child_type == "PRIZE" ?
													<p>3D:{discountPrize.showDisc3dPrize123 ? discountPrize.showDisc3dPrize123 : 0}%</p>
													: <p>3D:{discountPrize.showDisc3d}%</p>

										: game_sub_type === "TwoDDepan" || game_sub_type === "TwoDTengah" ?
											game_sub_child_type == "DISCOUNT" ?
												<p>2D:{discountPrize.showDisc2d}%</p>
												: game_sub_child_type == "FULLBET" ?
													<p></p>
													: game_sub_child_type == "PRIZE" ?
														<p>2D:{discountPrize.showDisc2dPrize123 ? discountPrize.showDisc2dPrize123 : 0}%</p>
														: <p>2D:{discountPrize.showDisc2d}%</p>
											: <p>4D:{discountPrize.showDisc4d}%,3D:{discountPrize.showDisc3d}%,2D:{discountPrize.showDisc2d}%</p>

							}
						</>
				) : (
					<>
						<p>{discountPrize.showDisc}% {validPaths.includes(window.location.pathname) && (
							<span >| kei:</span>
						)}


							<span>
								{window.location.pathname === "/game/Fifty_Fifty" ?
									(discountPrize?.kei_as_kecil ? `${discountPrize.kei_as_kecil}%` : '')
									: window.location.pathname === "/game/Fifty_Fifty_2D" ?
										(discountPrize?.kei_kecil ? `${discountPrize.kei_kecil}%` : '')
										: window.location.pathname === "/game/Tengah_Dasar" ?
											(discountPrize?.gametype === "tengahtepi" ?
												(discountPrize.keitengah ? `${discountPrize.keitengah}%` : '')
												: discountPrize.gametype === "dasar" ?
													(discountPrize.keibesar ? `${discountPrize.keibesar}%` : '')
													: '')
											: window.location.pathname === "/game/Silang_Kembang" ?
												(discountPrize?.gametype === "silanghomo" ?
													(discountPrize.kei_silang_depan ? `${discountPrize.kei_silang_depan}%` : '')
													: discountPrize.gametype === "kembangkempis" ?
														(discountPrize.kei_kembang_depan ? `${discountPrize.kei_kembang_depan}%` : '')
														: '')
												: ''}
							</span>

						</p>

					</>
				)}
			</div> */}
			<button
				// className='versiWap_mo_btn'
				className={
					app_type === "wap" || game_sub_type === "BALAK-BALIK"
						? "versiWap_mo_btn"
						: "versiWeb_mo_btn"
				}
				onClick={changeAppType}>
				{app_type === "wap" ? <img src={versiwebicon} alt="versiwebicon" className="icon" /> : <img src={versiwapicon} alt="versiwapicon" className="icon" />
				}
				{app_type === "desktop" ? "Versi WAP" : "Versi WEB"}</button>

			{isInfoResultPopup && (
				<div className="overlay">
					<div className="informasi_popup">
						<button className="informasi_popup-close" onClick={() => setIsInfoResultPopup(false)}>
							<IoMdClose className="btnclose" />
						</button>
						<InformasiResultPopup onClose={closeInformasiResultPopup} />
					</div>
				</div>
			)}

			{isInfoPopup && (
				<InformasiPopup response={respData} onClose={closeInformasiPopup} />
			)}
		</div>
	)
}

export default withTranslation()(VersiWAP)